import ArchivedOrderIsland from './components/archived-order-island/ArchivedOrderIsland.vue';
import CancelledOrderIsland from './components/cancelled-order-island/CancelledOrderIsland.vue';
import OrderDetailPanel from './components/order-detail-v1/OrderDetailPanel.vue';
import OrderNumberSequenceIsland from './components/order-number-sequence-island/OrderNumberSequenceIsland.vue';

export default function registerAdminVueComponents(app) {
    app.component('archived-order-island', ArchivedOrderIsland);
    app.component('cancelled-order-island', CancelledOrderIsland);
    app.component('order-detail-panel', OrderDetailPanel);
    app.component('order-number-sequence-island', OrderNumberSequenceIsland);
}
